import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Document } from 'shared/models/document';
import { Folder } from 'shared/models/folder';

import replaceFoldersChain from 'shared/utils/replaceFoldersChain';

import type { InitialState } from './types';
import { documentsApi } from './api';

const initialState: InitialState = {
  checkedEntities: [],
  foldersChain: [],
  searchTerm: '',
  showUploadForm: false,
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    addFolderToFoldersChain: (state, action: PayloadAction<Folder>) => {
      state.foldersChain.push(action.payload);
    },
    removeFolderFromFoldersChain: (state, action: PayloadAction<number>) => {
      state.foldersChain = state.foldersChain.slice(0, action.payload + 1);
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setCheckedEntities: (
      state,
      action: PayloadAction<(Document | Folder)[]>
    ) => {
      state.checkedEntities = action.payload;
    },
    setFoldersChain: (state, action: PayloadAction<Folder[]>) => {
      state.foldersChain = action.payload;
    },
    resetState: (state) => {
      Object.assign(state, initialState);
    },
    toggleShowUploadForm: (state) => {
      state.showUploadForm = !state.showUploadForm;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      documentsApi.endpoints.getDocuments.matchFulfilled,
      (state, { payload }) => {
        if (state.foldersChain.length) {
          state.foldersChain = replaceFoldersChain(state.foldersChain, payload);
          return;
        }

        state.foldersChain = [payload];
      }
    );
  },
});

export const {
  addFolderToFoldersChain,
  removeFolderFromFoldersChain,
  setCheckedEntities,
  setSearchTerm,
  setFoldersChain,
  resetState,
  toggleShowUploadForm,
} = documentsSlice.actions;
export default documentsSlice.reducer;
